// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-search[data-v-57e4a6a3] {\n  display: flex;\n  width: 46%;\n  justify-content: space-between;\n  margin-top: 10px;\n  margin-left: 10px;\n}\n.back-btn[data-v-57e4a6a3] {\n  width: 30%;\n  text-align: left;\n  padding-bottom: 20px;\n}\n.back-btn .el-button[data-v-57e4a6a3] {\n    width: 184px;\n    height: 48px;\n    border-radius: 4px;\n    font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
